export default "/_next/static/images/instagram-icon.svg";